import { BusinessDetailScreen } from '@/screens/business/business-detail/business-detail-screen';
export default BusinessDetailScreen;
